import styles from "@/components/VisualFilter/visual-filter.module.scss"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  getProducts,
  selectProductListState,
} from "@/store/features/productListSlice"
import parse from "html-react-parser"
import { useRouter } from "next/router"
import { getConfig } from "@/constants/config"
import _get from "lodash/get"
import { checkCategoryFilter, getAllFilterQueries } from "@/utils/helper"
import { resourceFacetLabels } from "@/constants/index"
import { getUserPersona } from "@/utils/helper"
import { getRowsInitialValue } from "@/utils/product"
import { getPriceSortQuery } from "@/utils/helper"

export function VisualFilter({ data, fullData }) {
  const [marketParamValues, setMarketParamValues] = useState(null)
  const rowsInitialValue = getRowsInitialValue()
  const paginationState = {
    rows: rowsInitialValue,
    start: 0,
  }
  const { rows, start } = paginationState
  const router = useRouter()
  const query = router.query
  const selectedCategory = query.Category
  const [category, setCategory] = useState(selectedCategory)
  const plpList = useSelector(selectProductListState).plp
  const categoryValue = plpList?.facets?.["**ProductLocalCategory_s"]
  const dispatch = useDispatch()

  const changeCategoryFilter = (e, title) => {
    document
      .querySelectorAll(".visual-filter__title")
      .forEach(el => el.classList.remove("--active"))

    // Add active to clicked
    e.currentTarget
      .querySelector(".visual-filter__title")
      .classList.add("--active")
    const object = {
      facet: "**ProductLocalCategory_s",
      value: [title],
      display: [title],
    }
    localStorage.setItem("selectedFilter", JSON.stringify(object))
    const componentProps = JSON.parse(localStorage.getItem("componentProps"))
    const { categoryKey } = componentProps
    const fusion = plpList.fusion
    const params = new URLSearchParams(window.location.search)
    const sort = params.get("sort")
    let newUrl = `${window.location.pathname}?Category=${encodeURIComponent(
      title
    )}`
    if (sort) {
      newUrl += `&sort=${sort}`
    }
    window.history.replaceState(
      window.location.pathname,
      document.title,
      `${newUrl}`
    )
    let filterQuery = getAllFilterQueries(
      componentProps,
      fusion,
      marketParamValues
    )
    filterQuery = checkCategoryFilter(filterQuery)
    updateProductList(filterQuery, categoryKey, sort)
    setCategory(title)
  }

  const updateProductList = (queries, categoryKey, sort) => {
    const fq = []
    queries?.forEach(q => {
      let tag = `{!tag="${q.facet}"}`

      if (!q.facet.match(/^\*{2}/)) {
        q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0
          ? fq.push(
              encodeURIComponent(
                `${
                  `{!tag="priceList.${persona}.finalPrice_d"}` +
                  `priceList.${persona}.finalPrice_d`
                }:(${q.value.join(" OR ")})`
              )
            )
          : fq.push(
              encodeURIComponent(
                `${tag + q.facet}:("${q.value.join('" OR "')}")`
              )
            )
        return
      }
      q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0
        ? fq.push(
            `${`priceList.${persona}.finalPrice_d`.replace(
              /^\*{2}/,
              ""
            )}:(${encodeURIComponent(q.value)})`
          )
        : fq.push(
            `${q.facet.replace(/^\*{2}/, "")}:("${encodeURIComponent(
              q.value.join('","')
            )}")`
          )
    })
    const persona = getUserPersona()
    const query = {
      fq,
      rows,
      start,
      fl: resourceFacetLabels(persona).join(","),
    }
    if (sort) {
      if (sort === "price asc") {
        query.sort = `${getPriceSortQuery(plpList?.grouped)}+asc`
      } else if (sort === "price desc") {
        query.sort = `${getPriceSortQuery(plpList?.grouped)}+desc`
      } else {
        query.sort = sort
      }
    }
    dispatch(getProducts({ profileName: categoryKey, query, update: false }))
      .then(() => {
        console.log("updated")
      })
      .catch(err => {
        console.log(err)
      })
  }

  const storeCategoryList = () => {
    let categoryArray = []
    if (localStorage.getItem("categoryArray")) {
      categoryArray = JSON.parse(localStorage.getItem("categoryArray"))
    }
    categoryArray.push(data.title ? parse(data.title) : "")
    localStorage.setItem("categoryArray", JSON.stringify(categoryArray))
  }

  useEffect(() => {
    if (category && data.title && data.title === category) {
      const el = document.querySelectorAll(".visual-filter__title")
      el.forEach(item => {
        if (item.innerText === category) {
          item.classList.add("--active")
        }
      })
      const object = {
        facet: "**ProductLocalCategory_s",
        value: category ? [parse(category)] : "",
        display: category ? [parse(category)] : "",
      }
      localStorage.setItem("selectedFilter", JSON.stringify(object))
    } else if (!category) {
      localStorage.removeItem("selectedFilter")
    }
    storeCategoryList()
    getConfig().then(config => {
      const marketParam = _get(config, "marketParamValues", {})
      setMarketParamValues(marketParam)
    })
  }, [])

  useEffect(() => {
    document
      .querySelectorAll(".visual-filter__title")
      .forEach(el => el.classList.remove("--active"))
    if (categoryValue && categoryValue.length === 2) {
      let categoryTitle = categoryValue[0]
      const el = document.querySelectorAll(".visual-filter__title")
      el.forEach(item => {
        if (item.innerText === categoryTitle) {
          console.log(categoryTitle, item.innerText)
          item.classList.add("--active")
        }
      })
    }
  }, [categoryValue])
  return (
    <div className={styles.visualFilter}>
      <div
        onClick={e =>
          changeCategoryFilter(e, data.title ? parse(data.title) : "")
        }
      >
        <div className="visual-filter">
          <div className="visual-filter__image">
            <img src={`${data.imageUrl}`} />
          </div>
          <div className={`visual-filter__title`}>
            {data.title ? parse(data.title) : ""}
          </div>
        </div>
      </div>
    </div>
  )
}
